import { useQuery } from '@tanstack/react-query';
import { ApiService } from '../../../core/services';
import { Session } from '../../simulator/models';
import { LabMetaData } from '../models';

export const SESSION_QUERY_KEYS = {
  GET_ACTIVE_SESSION_BY_LAB_ID: 'getActiveSessionByLabId',
};

export interface UseGetActiveSimulationSessionsProps {
  labId: LabMetaData['id'] | null;
}

export const useGetActiveSimulationSessions = ({ labId }: UseGetActiveSimulationSessionsProps) => {
  return useQuery({
    queryKey: [SESSION_QUERY_KEYS.GET_ACTIVE_SESSION_BY_LAB_ID, { labId }],
    queryFn: () => ApiService.get<Array<Session>>(`/me/active-sessions/${labId}/excluded`).then((res) => res.data),
    enabled: labId !== null,
  });
};
